export const isRegistrationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_REGISTRATION !== "false";

export const isSongVerificationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_SONG_VERIFICATION !== "false";

export const isWazaAirEnabled =
  process.env.NEXT_PUBLIC_ENABLE_WAZA_AIR !== "false";
